import {Component, OnDestroy, OnInit, Input, Injector} from '@angular/core';
import { Router } from '@angular/router';
import { EventManager } from 'src/app/core';
import { UpdateNavPopupComponent } from 'src/app/modules/product/components/update-nav-popup/update-nav-popup.component';
import { ProductService } from '../../product.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from "rxjs";
import { AppQueries } from 'src/app/state';
import { ManageComponent } from 'src/app/shared/components/manage.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Constant } from '../../../../core/constant';
@Component({
  selector: 'app-fund-list',
  templateUrl: './fund-list.component.html',
  styleUrls: ['./fund-list.component.scss']
})
export class FundListComponent extends ManageComponent implements OnInit, OnDestroy {
  @Input() title: any;
  @Input() list?: any[];
  @Input() queryParams: any = {};
  @Input() searchParams: any = {};
  setting: any = {};
  subscriptions: Subscription[] = [];
  constructor(
  public injector: Injector,
    public eventManager: EventManager,
    public router: Router,
    private appQueries: AppQueries,
    private productService: ProductService,
    public modalService: NzModalService,
    private toastService: ToastrService
  ) {
    super(eventManager, modalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subscriptions = [
      this.appQueries.userProfile$
        .subscribe((userProfile) => {
          userProfile = userProfile || {};
          if (userProfile.isAdmin) {
            this.queryConfig();
          }
      }),
    ];
    this.executeCallAPI();
  }
  loadAll(req?: any) {
    this.queryParams.searchParams.statusId = [6, 7, 9];
    this.queryParams.searchParams.typeCodes = [ Constant.CODE_TRADING_FUND, Constant.CODE_NEW_FUND];
    req = req || this.queryParams;
    this.list = [];
    this.productService
      .queryFund(req)
      .subscribe(this.onResponse.bind(this));
  }
  transferFee(id, name) {
    this.router.navigate(['products/fund/fee-transfer/' + id + '/' + name]);
  }
  openPopupNAV() {
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzOkDisabled: true,
      nzContent: UpdateNavPopupComponent,
      nzFooter: null,
      nzData: {
      },
      nzOnOk: (() => { })
    });
  }
  queryConfig() {
    this.productService.queryConfig()
    .subscribe((res) => {
      const list = res.list || [];
      const setting = list.find((item) => item.key === 'BACKEND.FMARKET2.FUND.PERSONAL_TAX') || {};
      this.setting = setting;
    })
  }
  updateConfig() {
    this.productService.editConfig(this.setting)
    .subscribe((res) => {
      this.toastService.success('Sửa thuế thành công!');
    })
  }
  create() {
    this.router.navigate(['products/fund/create']);
  }
  edit(id) {
    this.router.navigate(['products/fund/edit/' + id]);
  }
  addNewFee(item) {
    this.router.navigate(['products/fund/new-fee/' + item.id]);
  }
  confirmUpdateConfig() {
    this.confirmAction(null, `Bạn chắc chắn muốn sửa thuế `, this.updateConfig.bind(this));
  }
  approve(id) {
    this.router.navigate(['products/fund/approve/' + id]);
  }
  delete() {
    const body = {
      statusCode: 'PRODUCT_HIDDEN'
    }
    this.productService.hidden(this.selectedItem.id, body)
    .subscribe((res) => {
      this.toastService.success('Ẩn Sản Phẩm Thành Công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  confirmDelete(selectedItem) {
    this.confirmAction(selectedItem, `Bạn chắc chắn muốn ẩn sản phẩm : ${selectedItem.name}`, this.delete.bind(this));
  }
  active() {
    const body = {
      statusCode: 'PRODUCT_ACTIVE'
    }
    this.productService.hidden(this.selectedItem.id, body)
    .subscribe((res) => {
      this.toastService.success('Hiện Sản Phẩm Thành Công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  confirmActive(selectedItem) {
    this.confirmAction(selectedItem, `Bạn chắc chắn muốn hiện sản phẩm : ${selectedItem.name}`, this.active.bind(this));
  }
}
